import {
  GiftPartner,
  GiftPartnerDate,
  GiftPartnerOverview,
} from '@shared/api/giftPartner/giftPartner.interface';
import { kstDateTimeLabel } from '@shared/utils/kstTime.util';

export const brandIds = (partner: GiftPartner) =>
  partner.giftItemBrands.map((b) => (typeof b === 'string' ? b : b._id));
export const partnerStatus = (p: GiftPartner) =>
  p.status === 'Requested'
    ? '승인 대기'
    : p.status === 'Rejected'
    ? '반려'
    : p.isEnabled
    ? '연동 중'
    : '중지됨';
export const dateLabel = (v?: GiftPartnerDate) =>
  v ? kstDateTimeLabel(new Date(v)) : '—';
export type OverviewBrand = GiftPartnerOverview['brands'][number];
export const brandUnavailable = (b: OverviewBrand, partnerId?: string): string => {
  if (b.managedElsewhere) return '다른 담당 범위에서 관리 중';
  if (b.partner && b.partner !== partnerId) return '이미 신청 또는 연동된 브랜드';
  if (b.pendingPartner && b.pendingPartner !== partnerId)
    return '다른 연동에 추가 승인 대기';
  return '';
};
export const isIp = (value: string) => {
  if (/^(25[0-5]|2[0-4]\d|1?\d?\d)(\.(25[0-5]|2[0-4]\d|1?\d?\d)){3}$/.test(value))
    return true;
  if (!value.includes(':') || /[^\da-f:.]/i.test(value)) return false;
  try {
    return new URL(`https://[${value}]/`).hostname.startsWith('[');
  } catch {
    return false;
  }
};
export const hookUrlError = (value: string) => {
  if (!value.trim()) return '';
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:') return 'https 주소만 가능합니다';
    if (url.username || url.password) return '주소에 계정정보를 포함할 수 없습니다';
    const host = url.hostname.toLowerCase().replace(/\.$/, '');
    const parts = host.split('.').map(Number);
    if (
      host === 'localhost' ||
      host.endsWith('.localhost') ||
      host.endsWith('.local') ||
      host === '[::1]' ||
      host === '[::]' ||
      /^\[(fc|fd|fe[89ab])/i.test(host) ||
      host.startsWith('[::ffff:') ||
      parts[0] === 0 ||
      parts[0] === 10 ||
      parts[0] === 127 ||
      (parts[0] === 192 && parts[1] === 168) ||
      (parts[0] === 169 && parts[1] === 254) ||
      (parts[0] === 172 && (parts[1] ?? 0) >= 16 && (parts[1] ?? 0) <= 31)
    )
      return '내부망 주소는 등록할 수 없습니다';
    return '';
  } catch {
    return '주소 형식을 확인해 주세요';
  }
};
